import { getProfile } from "./account";
import { getCurrentUser } from "./auth";
import { getCart } from "./cart";
import { settingsApi } from "./arrex/settings";
import {
  getCategoryTabs,
  getCollections,
  getFilterFacets,
  getNewArrivals,
  getProduct,
  getProducts,
  getSubcategories,
} from "./products";

import type { ProductQuery } from "./types";
import { getFavoriteIds, getFavorites } from "./wishlist";

export const favoritesQuery = () =>
  ({ queryKey: ["favorites"] as unknown[], queryFn: getFavorites });

export const favoriteIdsQuery = () =>
  ({ queryKey: ["favorite-ids"] as unknown[], queryFn: getFavoriteIds });


export const productsQuery = (query: ProductQuery) =>
  ({
    queryKey: ["products", query] as unknown[],
    queryFn: () => getProducts(query),
  });

export const productQuery = (slug: string | undefined) =>
  ({
    queryKey: ["product", slug] as unknown[],
    queryFn: () => getProduct(slug!),
  });

export const newArrivalsQuery = () =>
  ({ queryKey: ["new-arrivals"] as unknown[], queryFn: getNewArrivals });

export const collectionsQuery = () =>
  ({ queryKey: ["collections"] as unknown[], queryFn: getCollections });

export const categoryTabsQuery = () =>
  ({ queryKey: ["category-tabs"] as unknown[], queryFn: getCategoryTabs });

export const subcategoriesQuery = (category: string) =>
  ({
    queryKey: ["subcategories", category] as unknown[],
    queryFn: () => getSubcategories(category),
  });


export const filterFacetsQuery = () =>
  ({ queryKey: ["filter-facets"] as unknown[], queryFn: getFilterFacets });

export const cartQuery = () => ({ queryKey: ["cart"] as unknown[], queryFn: getCart });

export const profileQuery = () => ({ queryKey: ["profile"] as unknown[], queryFn: getProfile });

export const currentUserQuery = () =>
  ({ queryKey: ["current-user"] as unknown[], queryFn: getCurrentUser });

export const settingsQuery = () =>
  ({ queryKey: ["settings"] as unknown[], queryFn: settingsApi.get });

export const heroSlidesQuery = () =>
  ({ queryKey: ["hero-slides"] as unknown[], queryFn: settingsApi.heroSlides });

export const myOrdersQuery = () =>
  ({ queryKey: ["my-orders"] as unknown[], queryFn: () => import("./orders").then(m => m.getMyOrders()) });
